/**
 * AuditoriaMotivoCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {AuditoriaMotivo} from '@/model/resource/AuditoriaMotivo'

/* TODO: review generated class */
@HttpExclude()
export class AuditoriaMotivoCollection extends PageCollection<AuditoriaMotivo> {
  constructor() {
    super(AuditoriaMotivo)
  }

  queryAsPage() {
    return this.listAuditoriaMotivo()
  }

  async listAuditoriaMotivo() {
    return await Request.get(`/admin/auditoria-motivo`, {params: this.params})
      .name('listAuditoriaMotivo')
      .as(this)
      .getResponse()
  }

  async listCsvAuditoriaMotivo() {
    return await Request.get(`/admin/auditoria-motivo/csv`, {
      params: this.params,
    })
      .name('listCsvAuditoriaMotivo')
      .as(this)
      .getResponse()
  }
}
